var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@material-ui/styles';
import { reaction } from 'mobx';
import * as reactRouterBrowser from 'react-router-dom';
import dotenv from 'dotenv';
import { LocalizationProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { inject, observer, Provider } from 'mobx-react';
import * as reactRouter from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import { configure } from 'mobx';
import 'typeface-open-sans';
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { theme } from '../theme';
import browserHistory from '../browserHistory';
import { LocationListen } from './LocationHistory';
import { initApp } from '../init';
import Sounds from '../components/Sounds';
import { globalUtils, IS_DEV_ENV, IS_STRONG_DEVICE } from '../utils';
import * as serviceWorker from '../serviceWorker';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { browserStorage } from '../browserStorage';
import { googleTagManager } from '../utils1';
import BlankPage from '../components/BlankPage';
import '../polyfils';
import PreloadingComponent from '../components/PreloadingComponent';
var ReportIssue = React.lazy(function () { return import('../components/ReportIssue'); });
var Router = reactRouter.Router;
var BrowserRouter = reactRouterBrowser.BrowserRouter;
configure({ isolateGlobalState: true });
var useToastStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        root: (_a = {
                maxWidth: "80vw!important",
                width: 'initial',
                '& .Toastify__toast-body': {
                    paddingRight: theme.spacing(1),
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                maxWidth: "100vw",
            },
            _a),
    });
});
var BaseComponent = observer(function (_a) {
    var children = _a.children, store = _a.store;
    return React.createElement(React.Fragment, { key: 1 }, children);
});
var findParent = function (target, index) {
    if (index === void 0) { index = 1; }
    if (index > 10 || !target) {
        return 0;
    }
    else if (target === null || target === void 0 ? void 0 : target.id) {
        return target;
    }
    else {
        return findParent(target.parentNode, index + 1);
    }
};
var DelayApp = inject('store')(observer(function (_a) {
    var client = _a.client, store = _a.store, App = _a.App;
    var classes = useToastStyles();
    var _b = __read(React.useState(false), 2), loaded = _b[0], setLoaded = _b[1];
    var _c = __read(React.useState([
        {
            name: 'click',
            context: document.body,
            callback: function (e) {
                try {
                    var attributes = ['name', 'title', 'id', 'className'];
                    var values = attributes
                        .map(function (k) {
                        var _a;
                        return e.target[k] || e.target.getAttribute(k)
                            ? (_a = {}, _a["izi_attribute_" + k] = e.target[k] || e.target.getAttribute(k), _a) : 0;
                    })
                        .filter(function (e) { return e; })
                        .reduce(function (a, b) { return (__assign(__assign({}, a), b)); }, {});
                    if (!values['izi_attribute_id']) {
                        var parent_1 = findParent(e.target);
                        if (parent_1)
                            Object.assign(values, attributes
                                .map(function (k) {
                                var _a;
                                return parent_1[k] || parent_1.getAttribute(k)
                                    ? (_a = {}, _a["izi_attribute_" + k] = parent_1[k] || parent_1.getAttribute(k), _a) : 0;
                            })
                                .filter(function (e) { return e; })
                                .reduce(function (a, b) { return (__assign(__assign({}, a), b)); }, {}));
                    }
                    if (values['izi_attribute_id']) {
                        googleTagManager('event', 'izi_click', values);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            },
        },
    ]), 1), events = _c[0];
    function initGlobalCss() {
        var css = document.createElement('style');
        css.innerHTML = "[data-title-1] {\n    position: relative;\n  }\n\n  [data-title-1]:not([data-title-1=\"\"]):after {\n    pointer-events: none;\n    content: attr(data-title-1);\n    position: absolute;\n    right: 0;\n    z-index: 9999999;\n    max-width: 100%;\n    min-width: 100px;\n    padding: 0px 6px;\n    color:white;\n    border-radius: 2px;\n    top: 100%; /* put it on the top */\n    background-color: rgba(0,0,0,0.8);\n    width: max-content;\n    opacity: 0;\n    font-size: 12px;\n    -webkit-transition: opacity 0.75s ease-in-out; /* \uD83D\uDC48 Change the time to meet your requirements. */\n  }\n\n  [data-title-1]:hover:after {\n    opacity: 1!important;\n  }\n    [ data-title]{\n      position: relative;\n     }\n      [data-title]:not([data-title=\"\"]):after {\n    content: attr(data-title);\n    position: absolute;\n    left: 0;\n    padding: 2px;\n    word-wrap: break-word;\n    font-family: Montserrat;\n    font-weight: 500;\n    line-height: 1.4em;\n    font-size: 14px;\n    color: #002B69;\n    border: 1px solid #BAB8B8;\n    border-radius: 5px;\n    background-color: #F6F6F6;\n    transform: none;\n    transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    \n    bottom: 100%; /* put it on the top */\n  \n    width: max-content;\n    opacity: 0;\n   \n  }\n\n  [data-title]:hover:after {\n    opacity: 1!important;\n  }\n    .bell{\n  display:block;\n    \n  -webkit-animation: ring 4s .7s ease-in-out 1;\n  -webkit-transform-origin: 50% 4px;\n  -moz-animation: ring 4s .7s ease-in-out 1;\n  -moz-transform-origin: 50% 4px;\n  animation: ring 4s .7s ease-in-out 1;\n  transform-origin: 50% 4px;\n}\n\n@-webkit-keyframes ring {\n  0% { -webkit-transform: rotateZ(0); }\n  1% { -webkit-transform: rotateZ(30deg); }\n  3% { -webkit-transform: rotateZ(-28deg); }\n  5% { -webkit-transform: rotateZ(34deg); }\n  7% { -webkit-transform: rotateZ(-32deg); }\n  9% { -webkit-transform: rotateZ(30deg); }\n  11% { -webkit-transform: rotateZ(-28deg); }\n  13% { -webkit-transform: rotateZ(26deg); }\n  15% { -webkit-transform: rotateZ(-24deg); }\n  17% { -webkit-transform: rotateZ(22deg); }\n  19% { -webkit-transform: rotateZ(-20deg); }\n  21% { -webkit-transform: rotateZ(18deg); }\n  23% { -webkit-transform: rotateZ(-16deg); }\n  25% { -webkit-transform: rotateZ(14deg); }\n  27% { -webkit-transform: rotateZ(-12deg); }\n  29% { -webkit-transform: rotateZ(10deg); }\n  31% { -webkit-transform: rotateZ(-8deg); }\n  33% { -webkit-transform: rotateZ(6deg); }\n  35% { -webkit-transform: rotateZ(-4deg); }\n  37% { -webkit-transform: rotateZ(2deg); }\n  39% { -webkit-transform: rotateZ(-1deg); }\n  41% { -webkit-transform: rotateZ(1deg); }\n\n  43% { -webkit-transform: rotateZ(0); }\n  100% { -webkit-transform: rotateZ(0); }\n}\n\n@-moz-keyframes ring {\n  0% { -moz-transform: rotate(0); }\n  1% { -moz-transform: rotate(30deg); }\n  3% { -moz-transform: rotate(-28deg); }\n  5% { -moz-transform: rotate(34deg); }\n  7% { -moz-transform: rotate(-32deg); }\n  9% { -moz-transform: rotate(30deg); }\n  11% { -moz-transform: rotate(-28deg); }\n  13% { -moz-transform: rotate(26deg); }\n  15% { -moz-transform: rotate(-24deg); }\n  17% { -moz-transform: rotate(22deg); }\n  19% { -moz-transform: rotate(-20deg); }\n  21% { -moz-transform: rotate(18deg); }\n  23% { -moz-transform: rotate(-16deg); }\n  25% { -moz-transform: rotate(14deg); }\n  27% { -moz-transform: rotate(-12deg); }\n  29% { -moz-transform: rotate(10deg); }\n  31% { -moz-transform: rotate(-8deg); }\n  33% { -moz-transform: rotate(6deg); }\n  35% { -moz-transform: rotate(-4deg); }\n  37% { -moz-transform: rotate(2deg); }\n  39% { -moz-transform: rotate(-1deg); }\n  41% { -moz-transform: rotate(1deg); }\n\n  43% { -moz-transform: rotate(0); }\n  100% { -moz-transform: rotate(0); }\n}\n\n@keyframes ring {\n  0% { transform: rotate(0); }\n  1% { transform: rotate(30deg); }\n  3% { transform: rotate(-28deg); }\n  5% { transform: rotate(34deg); }\n  7% { transform: rotate(-32deg); }\n  9% { transform: rotate(30deg); }\n  11% { transform: rotate(-28deg); }\n  13% { transform: rotate(26deg); }\n  15% { transform: rotate(-24deg); }\n  17% { transform: rotate(22deg); }\n  19% { transform: rotate(-20deg); }\n  21% { transform: rotate(18deg); }\n  23% { transform: rotate(-16deg); }\n  25% { transform: rotate(14deg); }\n  27% { transform: rotate(-12deg); }\n  29% { transform: rotate(10deg); }\n  31% { transform: rotate(-8deg); }\n  33% { transform: rotate(6deg); }\n  35% { transform: rotate(-4deg); }\n  37% { transform: rotate(2deg); }\n  39% { transform: rotate(-1deg); }\n  41% { transform: rotate(1deg); }\n\n  43% { transform: rotate(0); }\n  100% { transform: rotate(0); }\n}\n  ";
        document.head.appendChild(css);
    }
    React.useEffect(function () {
        if (IS_DEV_ENV) {
            window.storeItem = store;
        }
        if (store.hasBeenBuilt()) {
            setLoaded(true);
        }
        events.forEach(function (_a) {
            var name = _a.name, context = _a.context, callback = _a.callback;
            context.addEventListener(name, callback);
        });
        return function () {
            events.forEach(function (_a) {
                var name = _a.name, context = _a.context, callback = _a.callback;
                context.removeEventListener(name, callback);
            });
        };
    }, [store]);
    React.useEffect(function () {
        if (loaded) {
            store.accountStore.relogin();
            initGlobalCss();
        }
    }, [loaded]);
    React.useEffect(function () {
        if (!browserStorage.getItem('logistics-latest-visit')) {
            browserStorage.setItem('logistics-latest-visit', location.pathname);
        }
        var _a = store.accountStore, isChecked = _a.isChecked, isLoggedIn = _a.isLoggedIn, isSocketConnected = _a.isSocketConnected;
        if (isChecked && ((isLoggedIn && isSocketConnected) || !isLoggedIn)) {
            var preloader_1 = document.getElementById('preloader');
            if (preloader_1) {
                preloader_1.className = 'fade-out'; //
                var cleanAnimation_1 = function () {
                    var elements = __spread((document.getElementsByClassName('loader--dot') || []), (document.getElementsByClassName('loader--text') || []), (document.getElementsByClassName('loader--spotlight') || []));
                    if (elements === null || elements === void 0 ? void 0 : elements.length) {
                        var _loop_1 = function (i) {
                            elements[i].className = '';
                            setTimeout(function () {
                                elements[i].parentNode.removeChild(elements[i]);
                            }, 1000);
                        };
                        for (var i = 0; i < elements.length; i++) {
                            _loop_1(i);
                        }
                    }
                    setTimeout(function () {
                        preloader_1.parentNode.removeChild(preloader_1);
                    }, 1000);
                };
                setTimeout(function () {
                    cleanAnimation_1();
                }, 1000);
            }
            if (!IS_STRONG_DEVICE) {
                document.body.className += ' weak-device';
            }
            globalUtils.sounds = new Sounds();
            setTimeout(function () { return browserStorage.removeItem('logistics-latest-visit'); }, 1000);
        }
    }, [store.accountStore.isChecked, store.accountStore.isSocketConnected, store.accountStore.isLoggedIn]);
    if (!loaded || !store.accountStore.isChecked)
        return null;
    return (React.createElement(ApolloProvider, { client: client },
        React.createElement(PreloadingComponent, null,
            React.createElement(ReportIssue, { key: 'zendesk-service' })),
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(BrowserRouter, null,
                React.createElement(LocalizationProvider, { dateAdapter: MomentUtils },
                    React.createElement(ToastContainer, { position: "top-center", className: classes.root, autoClose: 5000, hideProgressBar: true, transition: Slide, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: false, limit: 3 }),
                    React.createElement(Router, { history: browserHistory },
                        React.createElement(LocationListen, { URL: URL }),
                        React.createElement(BaseComponent, { store: store }, store.accountStore.isApiLoaded ? (React.createElement(App, { store: store, key: [(store.accountStore.isLoggedIn && 1) || -1, store.accountStore.isWatingScreen ? 1 : -1] })) : (React.createElement(BlankPage, null)))))))));
}));
export var baseWithAllProviders = function (App, client, Store, URL) {
    dotenv.config();
    initApp();
    var store = Store.create();
    reaction(function () { return !store.accountStore.isLoggedIn; }, function () { return store.clear(); });
    return (React.createElement(Provider, { store: store },
        React.createElement(DelayApp, __assign({}, { client: client, store: store, App: App }))));
};
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA//
serviceWorker.register();
